import { render } from "./jump.vue?vue&type=template&id=5a7abfda"
import script from "./jump.vue?vue&type=script&lang=js"
export * from "./jump.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__